// Templates de stories (9:16) com os dados da oferta. Reusa o motor da marca
// d'agua: as camadas sao as mesmas (texto/selo), convertidas em operacoes de
// desenho por layerToOp, e o bot desenha com o mesmo SVG + sharp. Aqui so ha o
// modelo, os 10 modelos prontos e o layout em pixels (puro e deterministico).
import { layerToOp, } from "../watermark/layout.js";
export const STORY_WIDTH = 1080;
export const STORY_HEIGHT = 1920;
/** Templates proprios ativos por tenant. Espelhado na RPC create_story_template. */
export const MAX_CUSTOM_STORY_TEMPLATES = 10;
/** Upload do fundo: PNG/JPEG/WebP ate 5 MB (espelhado no bucket). */
export const STORY_TEMPLATE_MAX_BYTES = 5 * 1024 * 1024;
export const STORY_TEMPLATE_MIME_TYPES = ["image/png", "image/jpeg", "image/webp"];
/** Fracao (0..1) para pixels da tela 9:16, sempre dentro dela e com lado >= 1. */
export function toStoryPx(box, width = STORY_WIDTH, height = STORY_HEIGHT) {
    const x = Math.min(width - 1, Math.max(0, Math.round(box.x * width)));
    const y = Math.min(height - 1, Math.max(0, Math.round(box.y * height)));
    return {
        x,
        y,
        w: Math.max(1, Math.min(width - x, Math.round(box.w * width))),
        h: Math.max(1, Math.min(height - y, Math.round(box.h * height))),
    };
}
const CARD_PADDING = 24;
function cardFor(photo, rect, width, height) {
    if (photo.card === null)
        return null;
    const x = Math.max(0, rect.x - CARD_PADDING);
    const y = Math.max(0, rect.y - CARD_PADDING);
    return {
        rect: { x, y, w: Math.min(width - x, rect.w + 2 * CARD_PADDING), h: Math.min(height - y, rect.h + 2 * CARD_PADDING) },
        color: photo.card,
        radius: 36,
    };
}
/** Layout em pixels: fundo, cartao + foto do produto e camadas com os dados. */
export function computeStoryLayout(design, data) {
    const width = STORY_WIDTH;
    const height = STORY_HEIGHT;
    const photoRect = toStoryPx(design.photo.box, width, height);
    const ops = design.layers
        .map((layer) => layerToOp(layer, data, (box) => toStoryPx(box, width, height), false))
        .filter((op) => op !== null);
    return {
        width,
        height,
        background: design.background,
        photoRect,
        photoCard: cardFor(design.photo, photoRect, width, height),
        photoFit: design.photo.fit,
        ops,
    };
}
//# sourceMappingURL=design.js.map